export const GET_ALL_Fee = 'GET_ALL_Fee';
export const GET_ALL_FEE_SUCCESS = 'GET_ALL_FEE_SUCCESS';
export const GET_ALL_Enable = 'GET_ALL_Enable';
export const GET_ALL_Enable_SUCCESS = 'GET_ALL_Enable_SUCCESS';
export const SET_LOADER = 'set_loader';